import styles from "./index.module.css";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toggleNormalDropdown } from "../../../store/slices/dropdown/toggle.slice";
const DropDown = ({ steps, selectedValue, onChange, type, className }) => {
  const dispatch = useDispatch();
  const isClose = useSelector((store) => store.toggleDropdown.dropdown);
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    setSelected(selectedValue);
  }, [selectedValue]);

  useEffect(() => {
    setIsOpen(false);
  }, [isClose]);

  const onToggle = (e) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  const onValueSelect = (e) => {
    const target = e.currentTarget || e.target;
    if (target?.dataset?.value && target?.dataset?.index) {
      const index = parseInt(target.dataset.index);
      onChange(target.dataset.value, index);
      setSelected(index);
      setIsOpen(false);
    }
  };

  return (
    <div className={`${styles["container"]} ${className || ""}`.trim()}>
      <div className={styles["selected"]} onClick={onToggle}>
        <div>
          {steps[selected]?.length > 15
            ? steps[selected].slice(0, 15) + "..."
            : steps[selected]}
        </div>
        <div>
          <div className={styles["down"]}>
            <i class="bi bi-chevron-down"></i>
          </div>
        </div>
      </div>
      <div
        className={
          !isOpen
            ? `${styles["dropdown"]} ${styles["collapse"]}`
            : styles["dropdown"]
        }
      >
        {steps?.map((step, idx) => (
          <div
            className={styles["dropdown-item"]}
            data-value={step}
            data-index={idx}
            onClick={onValueSelect}
            key={idx}
          >
            {step}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DropDown;
